import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  Output,
} from '@angular/core';
import type { ControlValueAccessor, UntypedFormControl } from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const CHECKBOX_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FmCheckboxComponent),
  multi: true,
};

@Component({
  standalone: false,
  selector: 'invd-fm-checkbox',
  templateUrl: './fm-checkbox.component.html',
  styleUrls: ['./fm-checkbox.component.scss'],
  providers: [CHECKBOX_VALUE_ACCESSOR],
})
export class FmCheckboxComponent implements ControlValueAccessor {
  @Input() value: any;

  @Input() name: string;

  @Input() disabled: boolean;

  @Input() binary: boolean;

  @Input() label: string;

  @Input() tabindex: number;

  @Input() inputId: string;

  @Input() style: any;

  @Input() styleClass: string;

  @Input() formControl: UntypedFormControl;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  model: any;

  focused = false;

  checked = false;

  private cd = inject(ChangeDetectorRef);

  onModelChange: (model: any) => void = () => {};

  onModelTouched: () => void = () => {};

  onClick(event, checkbox, focus: boolean) {
    event.preventDefault();

    if (this.disabled) {
      return;
    }

    this.checked = !this.checked;
    this.updateModel();

    if (focus) {
      checkbox.focus();
    }
    this.cd.detectChanges();
  }

  updateModel() {
    if (!this.binary) {
      if (this.checked) this.addValue();
      else this.removeValue();

      this.onModelChange(this.model);
      if (this.formControl) {
        this.formControl.setValue(this.model);
      }
    } else {
      this.onModelChange(this.checked);
    }

    this.onChange.emit(this.checked);
  }

  handleChange(event) {
    this.checked = event.target.checked;
    this.updateModel();
  }

  isChecked(): boolean {
    if (this.binary) return this.model;
    else return this.model && this.model.includes(this.value);
  }

  removeValue() {
    this.model = this.model.filter((val) => val !== this.value);
  }

  addValue() {
    if (this.model) this.model = [...this.model, this.value];
    else this.model = [this.value];
  }

  onFocus(_event) {
    this.focused = true;
  }

  onBlur(_event) {
    this.focused = false;
    this.onModelTouched();
  }

  writeValue(model: any): void {
    this.model = model;
    this.checked = this.isChecked();
    this.cd.markForCheck();
  }

  registerOnChange(fn: (model: any) => void): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }
}
